<div class="prototype-select-field">
  <label *ngIf="label" class="prototype-select-field__label">
    <span>{{ label }}</span>
    <span *ngIf="required" class="prototype-select-field__required">*</span>
  </label>

  <div class="prototype-select-field__control">
    <mat-form-field appearance="fill" subscriptSizing="dynamic" class="prototype-select-field__form-field"
      [ngClass]="{'prototype-select-field__form-field--clearable': clearable && hasValue && !disabled}">
      <mat-select
        [value]="value"
        [placeholder]="placeholder"
        [disabled]="disabled"
        panelClass="prototype-select-panel"
        (selectionChange)="onSelectionChange($event.value)">
        <mat-option *ngFor="let option of options; trackBy: trackByValue" [value]="option.value" [disabled]="option.disabled">
          {{ option.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button
      *ngIf="clearable && hasValue && !disabled"
      type="button"
      class="prototype-select-field__clear"
      title="Limpar seleção"
      aria-label="Limpar seleção"
      (mousedown)="stopMouseDown($event)"
      (click)="clearValue($event)">
      <lucide-icon [img]="clearIcon" class="h-3.5 w-3.5"></lucide-icon>
    </button>
  </div>
</div>